<div class="px-3 py-3">
    <div class="row justify-content-center">
    <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 self-align-center">
      <mat-card class="shadow">
        <form [formGroup]="importPromocodeForm" (ngSubmit)="onSubmit()"> 
          <h3 class="content-label-each">Promo Code Import</h3>
          <div class="row my-4">
            <div class="form-group">
                <div class="col-lg-6 col-md-6 col-sm-6 col-xs-12 align-self-center">
                <div class="form-item-input">
                <input type="file"
                       id="file"
                       formControlName="file"
                       (change)="handleFileInput($event.target.files)"
                      > 
                </div>
                </div>       
            </div>
          </div>
          <div class="form-footer mt-6">
            <ul class="list-inline text-center">
              <li class="list-inline-item">
                <button
                  mat-raised-button
                  color="primary"
                  type="submit"
                  [disabled]="!importPromocodeForm.valid || !fileuploaded"
                  class="rounded-0"
                > 
                  <span translate class="translate">Submit</span>
                </button>
              </li>
              <li class="list-inline-item">
                <button
                 mat-stroked-button
                  color="primary"
                  type="button"
                  class="rounded-0"
                  (click)="onCancel()"
                >
                  <span translate class="translate">pages.newRetailer.cancel</span>
                </button>
              </li>
            </ul>
          </div>
        </form>
      </mat-card>
    </div>
  </div>
  </div>